export default function Photography() {
  return (
    <div>
      <h1>Photography</h1>
    </div>
  );
}
